import React from "react";

const Br = ({height = 5}) => {
    return (<div style={{height: `${height}px`}}/>);
}
export default Br;
